export const LOAN_GUARANTEE_CHEQUE_INTENT = {
  OwnSayadCheque: "1",
  GuarantorWithSayadCheque: "2",
  AcquiringCheque: "3",
};

export const loanGuaranteeChequeIntentOptions = [
  {
    value: LOAN_GUARANTEE_CHEQUE_INTENT.OwnSayadCheque,
    label: "چک صیادی دارم",
  },
  {
    value: LOAN_GUARANTEE_CHEQUE_INTENT.GuarantorWithSayadCheque,
    label: "ضامن دارای چک صیادی دارم",
  },
  {
    value: LOAN_GUARANTEE_CHEQUE_INTENT.AcquiringCheque,
    label: "برای دریافت چک اقدام می‌کنم",
  },
];

export const resolveLoanGuaranteeChequeIntentLabel = (value) => {
  const key = value == null || value === "" ? "" : String(value);
  return (
    loanGuaranteeChequeIntentOptions.find((opt) => opt.value === key)?.label ||
    ""
  );
};

export const LOAN_GUARANTEE_CHEQUE_INTENT_HELP =
  "وضعیت چک صیادی را مشخص کنید. اگر ضامن دارید، مشخصات ضامن را همین‌جا وارد کنید.";

export const LOAN_GUARANTEE_CHEQUE_GUARANTOR_ALERT =
  "لطفاً مشخصات ضامن را کامل وارد کنید تا استعلام اعتباری بدون رفت‌وبرگشت بعدی انجام شود.";

export const emptyGuarantorFormFields = {
  guarantorFirstName: "",
  guarantorLastName: "",
  guarantorNationalCode: "",
  guarantorMobile: "",
};

export const buildGuarantorSubmitPayload = (values) => {
  if (!values) return null;
  const firstName = String(values.guarantorFirstName || "").trim();
  const lastName = String(values.guarantorLastName || "").trim();
  const nationalCode = String(values.guarantorNationalCode || "").replace(/\D/g, "");
  const mobile = String(values.guarantorMobile || "").replace(/\D/g, "");
  if (!firstName && !lastName && !nationalCode && !mobile) return null;
  return {
    firstName,
    lastName,
    nationalCode,
    mobile,
  };
};